import { render, staticRenderFns } from "./Airdropv2.vue?vue&type=template&id=87a4ef76&scoped=true&"
import script from "./Airdropv2.vue?vue&type=script&lang=js&"
export * from "./Airdropv2.vue?vue&type=script&lang=js&"
import style0 from "./Airdropv2.vue?vue&type=style&index=0&id=87a4ef76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a4ef76",
  null
  
)

export default component.exports